import configureCommands from "./configure-commands";
import { createInvokerWithCache } from "@drapejs/core";
import consola from 'consola';

consola.level = process.env.NODE_ENV === 'development' ? 5 : 3;

self.addEventListener('message', (msg) => {
    if (msg.data.type !== 'env-init') return;

    configureCommands(msg.data.env, createInvokerWithCache());
});

